const ToggleDescription = function ()
{

    const toggleSelected = function (el) 
    {
        let _parent = el.closest('.wrap-toggle');

        _parent.find('.p-toggle').slideToggle(200, function(){
            if( _parent.find('.p-toggle').is(":hidden") ) {
                _parent.find('span').text("+");
            } else {
                _parent.find('span').text("-");
            }
        });
    }

    return {
        init : function () {

            $(".p-sel-toggle").on("click", function(){
                toggleSelected( $(this) );
            });

        }
    }

}();

module.exports = ToggleDescription;